export default "__VITE_ASSET__8db0ebf2__"